import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/gcadmin/adminlogin/AdminLoginPage.css";

const AdminForgotPasswordPage = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [visible,  setVisible]  = useState(false);
  const [email,    setEmail]    = useState("");
  const [sent,     setSent]     = useState(false);
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);

  useEffect(() => { setTimeout(() => setVisible(true), 60); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email) { setError("Please enter your email address."); return; }

    setLoading(true);
    try {
      const res = await axios.post(`${baseUrl}/admin/auth/forgotPassword`, { email });

      if (res.data.success) {
        setSent(true);
      } else {
        setError(res.data.message || res.data.error || "Something went wrong. Please try again.");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data?.error || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`gcAdmin-login-page ${visible ? "gcAdmin-login-page--visible" : ""}`}>
      <div className={`gcAdmin-login-card ${visible ? "gcAdmin-login-card--visible" : ""}`}>

        {/* <div className="gcAdmin-login-icon">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none"
            stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
        </div> */}

        {!sent ? (
          <>
            <h2 className="gcAdmin-login-title">Forgot Password?</h2>
            <p className="gcAdmin-login-subtitle">Enter your email to receive a reset link</p>

            {error && (
              <p className="gcAdmin-login-error">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8"  x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {error}
              </p>
            )}

            <form className="gcAdmin-login-form" onSubmit={handleSubmit} noValidate>
              <div className="gcAdmin-login-field">
                <input
                  className="gcAdmin-login-input"
                  type="email"
                  placeholder="Admin Email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  autoComplete="email"
                  disabled={loading}
                />
              </div>

              <button
                type="submit"
                className={`gcAdmin-login-btn ${loading ? "gcAdmin-login-btn--loading" : ""}`}
                disabled={loading}
              >
                {loading ? <span className="gcAdmin-login-spinner" /> : "Send Reset Link"}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2 className="gcAdmin-login-title">Email Sent!</h2>
            <p className="gcAdmin-login-subtitle">
              We've sent a password reset link to <strong>{email}</strong>. Please check your inbox.
            </p>
            <button
              className="gcAdmin-login-btn"
              onClick={() => navigate("/admin/login")}
            >
              Back to Login
            </button>
          </>
        )}

        <button className="gcAdmin-login-back" onClick={() => navigate("/")} type="button">
          ← Back to Home
        </button>

      </div>
    </div>
  );
};

export default AdminForgotPasswordPage;